import React, { FC, useState } from 'react';

import { PublicPageContext } from '../../shared/context';
import { PublicPageSettings } from '../../shared/context/PublicPageContext';

const PublicPageSettingsProvider: FC = ({ children }) => {
  const [publicPageSettings, setPublicPageSettings] = useState<PublicPageSettings>({});

  return (
    <PublicPageContext.Provider value={[publicPageSettings, setPublicPageSettings]}>
      {children}
    </PublicPageContext.Provider>
  );
};

export default PublicPageSettingsProvider;
